import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarStarIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M14.42 14.0601H16.92V12.5601H13.84C12.854 13.8796 11.0421 13.7701 10.16 12.5601H7.08001V14.0601H9.58001C10.7367 15.1622 12.8743 15.4065 14.42 14.0601ZM18.4424 9.05573L16.8722 10.0961C16.091 10.6223 15.0934 10.2965 14.7443 9.80011H6.38L7.90002 6.70013H14.8198L14.8826 6.46984C14.8826 6.46984 13.3577 5.23217 13.3239 5.20013H6.96002L5.28003 8.68011H3.08002V10.2801H4.52002L4.03998 11.2601V17.1001C4.20166 19.8039 7.7033 19.5189 7.97998 17.5001H16.02C16.376 19.5596 19.7555 19.8243 19.96 17.1001V10.0299L18.4424 9.05572V9.05573ZM18.46 16.8001C18.46 17.1801 18.16 17.4801 17.78 17.4801C17.4 17.4801 17.12 17.1801 17.12 16.8001V16.0001H6.88V16.8001C6.88 17.1801 6.59997 17.4801 6.21997 17.4801C5.84003 17.4801 5.53998 17.1801 5.53998 16.8001V11.3001H18.46V16.8001ZM22.44 4.01941L19.487 3.87372L18.4438 1.12012L17.393 3.87372L14.44 4.01941L16.7487 5.86029L15.9664 8.72894L18.4439 7.08752L20.9136 8.72894L20.1313 5.86029L22.44 4.01941H22.44Z"
      />
    </SvgIcon>
  );
});
